<div class="side-bar__ctn" [class.minimised]="!fullSidebar">
  <div class="left-navigation-logo">
    <a routerLink="/">
      <img [src]="logo" class="logo-shiva" [class.d-none]="fullSidebar" alt="Logo"/>
      <img [src]="logoInline" class="logo-shiva" [class.d-none]="!fullSidebar" alt="Logo" [pTooltip]="VERSION"
        tooltipPosition="bottom" tooltipStyleClass="tooltip-light ordinary"/>
    </a>
    @if (fullSidebar) {
      <span
        class="fix-menu-btn"
        (click)="fixMenu()"
        [title]="(enableAutoCollapse ? 'common.enableAutoCollapseMenu' : 'common.disableAutoCollapseMenu') | translate"
        >
        @if (enableAutoCollapse) {
          <img ngSrc="/icons/menus/pin.svg" height="20" width="20" alt="">
        } @else {
          <img ngSrc="/icons/menus/unpin.svg" height="20" width="20" alt="">
        }
      </span>
    }
  </div>
  <div class="left-navigation-menu">
    <ul class="list-menu">
      @for (parent of groupedRoutes; track parent.parentId) {

        <li class="parent-route">
          <span>{{ 'leftMenuParent.' + parent.parentId | translate }}</span>
          <i [class]="parent.icon + ' menu-icon parent-menu-icon'"></i>
        </li>

        @for (route of parent.routes; track route.route) {
          <li>
            <a
              [routerLink]="'/' + route.route"
              [queryParams]="route.params"
              routerLinkActive="active"
              >
              <i [class]="route.icon + ' menu-icon'"></i>
              <span class="item-menu text-menu">{{ route.name | translate }}</span>
            </a>
          </li>
        }
      }
    </ul>
  </div>

  @if (autAppGuard !== NotAuthenticatedJustLoggedIn) {
    <ul class="left-navigation-second">
      <li (click)="quickAccess.toggle($event)">
        <i class="fas fa-grip"></i>
        <span class="item-menu">{{ 'menu.quickAccess.label' | translate }}</span>
      </li>
      <li>
        <i class="fas fa-user-circle"></i>
        <span class="item-menu ellipsis-user-name" [title]="userName">{{ userName }}</span>
      </li>
      <li (click)="logout()">
        <i [class]="iconClass.LOG_OUT + ' menu-icon'"></i>
        <span class="item-menu ellipsis-user-name">{{ 'menu.logout' | translate }}</span>
      </li>
    </ul>
  }

  <app-quick-access-panel #quickAccess (panelToggle)="panelToggle.emit($event)"></app-quick-access-panel>
</div>
